import { render, staticRenderFns } from "./Objective.vue?vue&type=template&id=46b0c546&scoped=true&"
import script from "./Objective.vue?vue&type=script&lang=js&"
export * from "./Objective.vue?vue&type=script&lang=js&"
import style0 from "./Objective.vue?vue&type=style&index=0&id=46b0c546&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b0c546",
  null
  
)

export default component.exports